import { render } from "./DocumentViewerModal.vue?vue&type=template&id=61be1502&scoped=true"
import script from "./DocumentViewerModal.vue?vue&type=script&lang=js"
export * from "./DocumentViewerModal.vue?vue&type=script&lang=js"

import "./DocumentViewerModal.vue?vue&type=style&index=0&id=61be1502&lang=scss&scoped=true"
import "./DocumentViewerModal.vue?vue&type=style&index=1&id=61be1502&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/demo-plus.centrodeglaucoma.com/darmin-plus-modular/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61be1502"]])

export default __exports__